import React from 'react'
import { arrayOf, oneOf, shape } from 'prop-types'
import { Badge } from '@offerzen/pinata-shame'

import BuildingIcon from '@offerzen/zenicon/BuildingIcon'
import ComputerIcon from '@offerzen/zenicon/ComputerIcon'
import WorldIcon from '@offerzen/zenicon/WorldIcon'
import WorkplacePolicyLocations from './WorkplacePolicyLocations'

import styles from './styles'

const HYBRID = 'HYBRID'
const REMOTE = 'REMOTE'
const OFFICE = 'OFFICE'
const policyListOrder = [REMOTE, HYBRID, OFFICE]

const WorkPlacePolicyPreview = ({ remotePolicies = [] }) => {
  const sortedRemotePolicies = remotePolicies.sort((a, b) => policyListOrder.indexOf(a.type) - policyListOrder.indexOf(b.type))
  return (
    <ul className={styles.remotePolicyList}>
      <For each="remotePolicy" of={sortedRemotePolicies}>
        <li key={remotePolicy.id} className={styles.remotePolicyItem}>
          <If condition={remotePolicy.type === HYBRID}>
            <Badge icon={ComputerIcon} size="small" theme="light" className={styles.badge} />
            <b>Hybrid work in:</b>
            <WorkplacePolicyLocations cities={remotePolicy.cities} />
          </If>

          <If condition={remotePolicy.type === OFFICE}>
            <Badge icon={BuildingIcon} size="small" theme="light" className={styles.badge} />
            <b>Office-based work in:</b>
            <WorkplacePolicyLocations cities={remotePolicy.cities} />
          </If>

          <If condition={remotePolicy.type === REMOTE}>
            <Badge icon={WorldIcon} size="small" theme="light" className={styles.badge} />
            <b>100% remote</b>
          </If>
        </li>
      </For>
    </ul>
  )
}

WorkPlacePolicyPreview.propTypes = {
  remotePolicies: arrayOf(
    shape({
      type: oneOf([REMOTE, HYBRID, OFFICE]),
    }),
  ),
}

export default WorkPlacePolicyPreview
